import React, { useEffect, useState } from "react";
import DashboardCards from "./DashboardCards/DashboardCards";
import DashboardTable from "./DashboardTable/DashboardTable";
import { getApiCaller } from "../../../../Libs/apiCaller";
import { FadeLoader } from "react-spinners";

export default function Dashboard() {
  const [userList, setUserList] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [search, setSearch] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [isCardLoading, setIsCardLoading] = useState(true);

  const getUserList = async (
    page = 1,
    srch = search,
    selTime = selectedTime
  ) => {
    let endPoint = `users/all_user?page=${page}&limit=10&search=${srch}`;
    if (selTime) endPoint += `&sortType=${selTime}`;
    const response = await getApiCaller(endPoint);
    if (response.status === 200) {
      window.scrollTo(0, 0);
      setSearch(srch);
      setCurrentPage(response.data.currentPage);
      setUserList(response.data.users);
      setTotalUsers(response.data.totalUsers);
      setTotalPages(response.data.totalPages);
    }
    setIsLoading(false);
  };

  const getCardData = async () => {
    const response = await getApiCaller("users/dashboard");
    if (response?.data?.data) setCardData(response?.data?.data);
    setIsCardLoading(false);
  };

  useEffect(() => {
    getCardData();
  }, []);

  useEffect(() => {
    setIsLoading(true);
    getUserList(1, search, selectedTime);
  }, [selectedTime]);

  return (
    <section className="p-2">
      {isCardLoading ? (
        <div className="h-25 flex items-center justify-center">
          <FadeLoader color="#7104F8" loading={true} size={12} />
        </div>
      ) : (
        <DashboardCards cardData={cardData} />
      )}
      <h1 className="text-2xl pt-4 pb-1 font-semibold text-black">
        Recently Joined Members
      </h1>
      <DashboardTable
        selectedTime={selectedTime}
        setSelectedTime={setSelectedTime}
        users={userList}
        isLoading={isLoading}
        setSearch={setSearch}
        currentPage={currentPage}
        totalPages={totalPages}
        totalUsers={totalUsers}
        getUserList={getUserList}
      />
    </section>
  );
}
